module.exports = __webpack_public_path__ + "img/zaluzie-cast.a2f0764b.svg";